import {
  Album,
  BookOpen,
  Brain,
  Aperture,
  LibraryBig,
  HandCoins,
  BotMessageSquare,
  Leaf,
} from 'lucide-react';

const CardGroupIllustrator = () => {
  return (
    <>
      <div
        data-lov-id="src/pages/Index.tsx:6:4"
        data-lov-name="div"
        data-component-path="src/pages/Index.tsx"
        data-component-line={6}
        data-component-file="Index.tsx"
        data-component-name="div"
        data-component-content="%7B%22className%22%3A%22min-h-screen%22%7D"
        className="min-h-screen"
      >
        <div
          data-lov-id="src/pages/Index.tsx:7:6"
          data-lov-name="div"
          data-component-path="src/pages/Index.tsx"
          data-component-line={7}
          data-component-file="Index.tsx"
          data-component-name="div"
          data-component-content="%7B%22className%22%3A%22max-w-7xl%20mx-auto%20py-12%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D"
          className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8"
        >
          <div
            data-lov-id="src/components/FeatureGrid.tsx:160:4"
            data-lov-name="div"
            data-component-path="src/components/FeatureGrid.tsx"
            data-component-line={160}
            data-component-file="FeatureGrid.tsx"
            data-component-name="div"
            data-component-content="%7B%22className%22%3A%22bg-gray-50%20p-8%20md%3Ap-12%20lg%3Ap-16%20w-full%20rounded-xl%20relative%22%7D"
            className="bg-gray-50 p-8 md:p-12 lg:p-16 w-full rounded-xl relative"
            id="hero-illustrator-container"
          >
            <svg
              data-lov-id="src/components/FeatureGrid.tsx:161:6"
              data-lov-name="svg"
              data-component-path="src/components/FeatureGrid.tsx"
              data-component-line={161}
              data-component-file="FeatureGrid.tsx"
              data-component-name="svg"
              data-component-content="%7B%22className%22%3A%22absolute%20top-0%20left-0%20w-full%20h-full%20z-0%20pointer-events-none%22%7D"
              className="absolute top-0 left-0 w-full h-full z-0 pointer-events-none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                data-lov-id="src/components/FeatureGrid.tsx:166:8"
                data-lov-name="path"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={166}
                data-component-file="FeatureGrid.tsx"
                data-component-name="path"
                data-component-content="%7B%22className%22%3A%22animate-path-trace%22%7D"
                d="M 300,140 Q 400,120 500,140"
                stroke="url(#neuralGradient)"
                strokeWidth="1.5"
                fill="none"
                strokeDasharray="5,5"
                className="animate-path-trace"
              />
              <path
                data-lov-id="src/components/FeatureGrid.tsx:175:8"
                data-lov-name="path"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={175}
                data-component-file="FeatureGrid.tsx"
                data-component-name="path"
                data-component-content="%7B%22className%22%3A%22animate-path-trace%22%7D"
                d="M 220,220 Q 280,190 350,220"
                stroke="url(#neuralGradient)"
                strokeWidth={1}
                fill="none"
                strokeDasharray="3,7"
                className="animate-path-trace"
                style={{ animationDelay: '0.4s' }}
              />
              <path
                data-lov-id="src/components/FeatureGrid.tsx:185:8"
                data-lov-name="path"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={185}
                data-component-file="FeatureGrid.tsx"
                data-component-name="path"
                data-component-content="%7B%22className%22%3A%22animate-path-trace%22%7D"
                d="M 450,220 Q 500,190 580,210"
                stroke="url(#neuralGradient)"
                strokeWidth={1}
                fill="none"
                strokeDasharray="3,7"
                className="animate-path-trace"
                style={{ animationDelay: '0.6s' }}
              />
              <path
                data-lov-id="src/components/FeatureGrid.tsx:195:8"
                data-lov-name="path"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={195}
                data-component-file="FeatureGrid.tsx"
                data-component-name="path"
                data-component-content="%7B%22className%22%3A%22animate-path-trace%22%7D"
                d="M 150,300 Q 200,240 250,290"
                stroke="url(#neuralGradient)"
                strokeWidth={1}
                fill="none"
                strokeDasharray="3,7"
                className="animate-path-trace"
                style={{ animationDelay: '0.8s' }}
              />
              <path
                data-lov-id="src/components/FeatureGrid.tsx:205:8"
                data-lov-name="path"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={205}
                data-component-file="FeatureGrid.tsx"
                data-component-name="path"
                data-component-content="%7B%22className%22%3A%22animate-path-trace%22%7D"
                d="M 500,300 Q 550,240 600,290"
                stroke="url(#neuralGradient)"
                strokeWidth={1}
                fill="none"
                strokeDasharray="3,7"
                className="animate-path-trace"
                style={{ animationDelay: '1s' }}
              />
              <circle
                data-lov-id="src/components/FeatureGrid.tsx:215:8"
                data-lov-name="circle"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={215}
                data-component-file="FeatureGrid.tsx"
                data-component-name="circle"
                data-component-content="%7B%22className%22%3A%22animate-neural-pulse%22%7D"
                cx={300}
                cy={140}
                r={3}
                fill="url(#neuralGradient)"
                className="animate-neural-pulse"
              />
              <circle
                data-lov-id="src/components/FeatureGrid.tsx:216:8"
                data-lov-name="circle"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={216}
                data-component-file="FeatureGrid.tsx"
                data-component-name="circle"
                data-component-content="%7B%22className%22%3A%22animate-neural-pulse%22%7D"
                cx={500}
                cy={140}
                r={3}
                fill="url(#neuralGradient)"
                className="animate-neural-pulse"
                style={{ animationDelay: '0.3s' }}
              />
              <circle
                data-lov-id="src/components/FeatureGrid.tsx:217:8"
                data-lov-name="circle"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={217}
                data-component-file="FeatureGrid.tsx"
                data-component-name="circle"
                data-component-content="%7B%22className%22%3A%22animate-neural-pulse%22%7D"
                cx={220}
                cy={220}
                r={2}
                fill="url(#neuralGradient)"
                className="animate-neural-pulse"
                style={{ animationDelay: '0.6s' }}
              />
              <circle
                data-lov-id="src/components/FeatureGrid.tsx:218:8"
                data-lov-name="circle"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={218}
                data-component-file="FeatureGrid.tsx"
                data-component-name="circle"
                data-component-content="%7B%22className%22%3A%22animate-neural-pulse%22%7D"
                cx={350}
                cy={220}
                r={2}
                fill="url(#neuralGradient)"
                className="animate-neural-pulse"
                style={{ animationDelay: '0.9s' }}
              />
              <circle
                data-lov-id="src/components/FeatureGrid.tsx:219:8"
                data-lov-name="circle"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={219}
                data-component-file="FeatureGrid.tsx"
                data-component-name="circle"
                data-component-content="%7B%22className%22%3A%22animate-neural-pulse%22%7D"
                cx={450}
                cy={220}
                r={2}
                fill="url(#neuralGradient)"
                className="animate-neural-pulse"
                style={{ animationDelay: '1.2s' }}
              />
              <circle
                data-lov-id="src/components/FeatureGrid.tsx:220:8"
                data-lov-name="circle"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={220}
                data-component-file="FeatureGrid.tsx"
                data-component-name="circle"
                data-component-content="%7B%22className%22%3A%22animate-neural-pulse%22%7D"
                cx={580}
                cy={210}
                r={2}
                fill="url(#neuralGradient)"
                className="animate-neural-pulse"
                style={{ animationDelay: '1.5s' }}
              />
              <defs
                data-lov-id="src/components/FeatureGrid.tsx:222:8"
                data-lov-name="defs"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={222}
                data-component-file="FeatureGrid.tsx"
                data-component-name="defs"
                data-component-content="%7B%7D"
              >
                <linearGradient
                  data-lov-id="src/components/FeatureGrid.tsx:223:10"
                  data-lov-name="linearGradient"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={223}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="linearGradient"
                  data-component-content="%7B%7D"
                  id="neuralGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop
                    data-lov-id="src/components/FeatureGrid.tsx:224:12"
                    data-lov-name="stop"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={224}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="stop"
                    data-component-content="%7B%7D"
                    offset="0%"
                    stopColor="#10B981"
                  />
                  <stop
                    data-lov-id="src/components/FeatureGrid.tsx:225:12"
                    data-lov-name="stop"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={225}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="stop"
                    data-component-content="%7B%7D"
                    offset="100%"
                    stopColor="#FBBF24"
                  />
                </linearGradient>
              </defs>
            </svg>
            <div
              data-lov-id="src/components/FeatureGrid.tsx:230:6"
              data-lov-name="div"
              data-component-path="src/components/FeatureGrid.tsx"
              data-component-line={230}
              data-component-file="FeatureGrid.tsx"
              data-component-name="div"
              data-component-content="%7B%22className%22%3A%22relative%20max-w-4xl%20mx-auto%20grid%20grid-cols-3%20sm%3Agrid-cols-5%20gap-4%20md%3Agap-8%22%7D"
              className="relative max-w-4xl mx-auto grid grid-cols-3 sm:grid-cols-5 gap-4 md:gap-8"
            >
              <div
                data-lov-id="src/components/FeatureGrid.tsx:231:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={231}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Ablock%22%7D"
                className="hidden sm:block"
              />
              <div
                data-lov-id="src/components/FeatureGrid.tsx:232:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={232}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Aflex%20justify-center%22%7D"
                className="hidden sm:flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:90:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={90}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#8B5CF6"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <circle
                      data-lov-id="src/components/StripeIcons.tsx:91:10"
                      data-lov-name="circle"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={91}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="circle"
                      data-component-content="%7B%7D"
                      cx={12}
                      cy={12}
                      r={8}
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:239:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={239}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="rounded-lg border text-card-foreground relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-white shadow-lg group hover:bg-green-50"
                >
                  <BookOpen id="bookOpen-icon" />
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:57:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={57}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22text-sm%20font-medium%20mt-2%20animate-fade-in%22%7D"
                    className="text-sm font-medium mt-2 animate-fade-in"
                  >
                    Career
                  </div>
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:61:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={61}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%7D"
                    className="absolute bg-gradient-to-r from-green-500 to-yellow-400 z-[-1] animate-scale-x-in animate-pulse-line h-[2px] top-1/2 -translate-y-1/2 left-0 -translate-x-full w-[100%] origin-right"
                  />
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:77:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={77}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20-top-1%20-right-1%20w-3%20h-3%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20animate-neural-pulse%22%7D"
                    className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 animate-neural-pulse"
                  />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:250:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={250}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="rounded-lg border text-card-foreground relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-white shadow-lg group hover:bg-yellow-50"
                >
                  <LibraryBig id="libraryBig-icon" />
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:57:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={57}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22text-sm%20font-medium%20mt-2%20animate-fade-in%22%7D"
                    className="text-sm font-medium mt-2 animate-fade-in"
                  >
                    Universites
                  </div>
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:61:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={61}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%7D"
                    className="absolute bg-gradient-to-r from-green-500 to-yellow-400 z-[-1] animate-scale-x-in animate-pulse-line h-[2px] top-1/2 -translate-y-1/2 right-0 translate-x-full w-[100%] origin-left"
                  />
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:77:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={77}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20-top-1%20-right-1%20w-3%20h-3%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20animate-neural-pulse%22%7D"
                    className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 animate-neural-pulse"
                  />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:261:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={261}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Aflex%20justify-center%22%7D"
                className="hidden sm:flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <Aperture id="aperture-icon" />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:269:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={269}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Ablock%22%7D"
                className="hidden sm:block"
              />
              <div
                data-lov-id="src/components/FeatureGrid.tsx:270:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={270}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="cards rounded-lg text-card-foreground shadow-sm relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-transparent border-[1px] border-gray-200 group hover:bg-purple-50"
                >
                  <HandCoins id="handCoins-icon" />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:280:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={280}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:85:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={85}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    
                    <rect
                      data-lov-id="src/components/StripeIcons.tsx:86:10"
                      data-lov-name="rect"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={86}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="rect"
                      data-component-content="%7B%7D"
                      x={4}
                      y={4}
                      width={16}
                      height={16}
                      rx={1}
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:287:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={287}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:100:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={100}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <path
                      data-lov-id="src/components/StripeIcons.tsx:101:10"
                      data-lov-name="path"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={101}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="path"
                      data-component-content="%7B%7D"
                      d="M3 12C5.5 8 7.5 16 12 12C16.5 8 17.5 16 21 12"
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:294:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={294}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="rounded-lg border text-card-foreground relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-white shadow-lg group hover:bg-blue-50"
                >
                  <Album id="album-icon" />

                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:57:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={57}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22text-sm%20font-medium%20mt-2%20animate-fade-in%22%7D"
                    className="text-sm font-medium mt-2 animate-fade-in"
                  >
                    Scholarships
                  </div>
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:77:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={77}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20-top-1%20-right-1%20w-3%20h-3%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20animate-neural-pulse%22%7D"
                    className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 animate-neural-pulse"
                  />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:305:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={305}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:90:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={90}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <circle
                      data-lov-id="src/components/StripeIcons.tsx:91:10"
                      data-lov-name="circle"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={91}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="circle"
                      data-component-content="%7B%7D"
                      cx={12}
                      cy={12}
                      r={8}
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:312:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={312}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Ablock%20col-span-2%22%7D"
                className="hidden sm:block col-span-2"
              />
              <div
                data-lov-id="src/components/FeatureGrid.tsx:313:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={313}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="rounded-lg border text-card-foreground relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-white shadow-lg group hover:bg-purple-50"
                >
                  <Brain id="brain-icon" />
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:57:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={57}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22text-sm%20font-medium%20mt-2%20animate-fade-in%22%7D"
                    className="text-sm font-medium mt-2 animate-fade-in"
                  >
                    Mental Health 
                  </div>
                  <div
                    data-lov-id="src/components/FeatureGrid.tsx:77:8"
                    data-lov-name="div"
                    data-component-path="src/components/FeatureGrid.tsx"
                    data-component-line={77}
                    data-component-file="FeatureGrid.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20-top-1%20-right-1%20w-3%20h-3%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20animate-neural-pulse%22%7D"
                    className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 animate-neural-pulse"
                  />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:323:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={323}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Ablock%22%7D"
                className="hidden sm:block"
              />
              <div
                data-lov-id="src/components/FeatureGrid.tsx:325:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={325}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Ablock%20col-span-2%22%7D"
                className="hidden sm:block col-span-2"
              />
              <div
                data-lov-id="src/components/FeatureGrid.tsx:326:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={326}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="cards flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="rounded-lg text-card-foreground shadow-sm relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-transparent border-[1px] border-gray-200 group hover:bg-blue-50"
                >
                  <BotMessageSquare id="botMessageSquare-icon" />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:336:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={336}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:95:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={95}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <path
                      data-lov-id="src/components/StripeIcons.tsx:96:10"
                      data-lov-name="path"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={96}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="path"
                      data-component-content="%7B%7D"
                      d="M12 4L20 18H4L12 4Z"
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:343:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={343}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22flex%20justify-center%22%7D"
                className="cards flex justify-center"
              >
                <div
                  data-lov-id="src/components/FeatureGrid.tsx:37:4"
                  data-lov-name="Card"
                  data-component-path="src/components/FeatureGrid.tsx"
                  data-component-line={37}
                  data-component-file="FeatureGrid.tsx"
                  data-component-name="Card"
                  data-component-content="%7B%7D"
                  className="rounded-lg text-card-foreground shadow-sm relative w-[100px] h-[100px] flex flex-col items-center justify-center p-4 transition-all duration-300 ease-out cursor-pointer hover:shadow-md hover:-translate-y-1 bg-transparent border-[1px] border-gray-200 group hover:bg-green-50"
                >
                  <Leaf id="leaf-icon" />
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:354:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={354}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Aflex%20justify-center%22%7D"
                className="hidden sm:flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:85:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={85}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <rect
                      data-lov-id="src/components/StripeIcons.tsx:86:10"
                      data-lov-name="rect"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={86}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="rect"
                      data-component-content="%7B%7D"
                      x={4}
                      y={4}
                      width={16}
                      height={16}
                      rx={1}
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:361:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={361}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Ablock%20col-span-2%22%7D"
                className="hidden sm:block col-span-2"
              />
              <div
                data-lov-id="src/components/FeatureGrid.tsx:362:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={362}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Aflex%20justify-center%22%7D"
                className="hidden sm:flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:95:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={95}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <path
                      data-lov-id="src/components/StripeIcons.tsx:96:10"
                      data-lov-name="path"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={96}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="path"
                      data-component-content="%7B%7D"
                      d="M12 4L20 18H4L12 4Z"
                    />
                  </svg>
                </div>
              </div>
              <div
                data-lov-id="src/components/FeatureGrid.tsx:369:8"
                data-lov-name="div"
                data-component-path="src/components/FeatureGrid.tsx"
                data-component-line={369}
                data-component-file="FeatureGrid.tsx"
                data-component-name="div"
                data-component-content="%7B%22className%22%3A%22hidden%20sm%3Aflex%20justify-center%22%7D"
                className="hidden sm:flex justify-center"
              >
                <div
                  data-lov-id="src/components/StripeIcons.tsx:77:4"
                  data-lov-name="div"
                  data-component-path="src/components/StripeIcons.tsx"
                  data-component-line={77}
                  data-component-file="StripeIcons.tsx"
                  data-component-name="div"
                  data-component-content="%7B%22className%22%3A%22w-10%20h-10%20flex%20items-center%20justify-center%20border%20border-gray-200%20rounded-md%20transition-all%20duration-300%20hover%3Abg-white%20hover%3Ashadow-sm%20hover%3Aborder-gray-300%20hover%3A-translate-y-1%20cursor-pointer%20group%22%7D"
                  className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-md transition-all duration-300 hover:bg-white hover:shadow-sm hover:border-gray-300 hover:-translate-y-1 cursor-pointer group"
                >
                  <div
                    data-lov-id="src/components/StripeIcons.tsx:82:6"
                    data-lov-name="div"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={82}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="div"
                    data-component-content="%7B%22className%22%3A%22absolute%20w-2%20h-2%20rounded-full%20bg-gradient-to-r%20from-green-400%20to-yellow-400%20opacity-0%20group-hover%3Aopacity-100%20animate-neural-pulse%22%7D"
                    className="absolute w-2 h-2 rounded-full bg-gradient-to-r from-green-400 to-yellow-400 opacity-0 group-hover:opacity-100 animate-neural-pulse"
                  />
                  <svg
                    data-lov-id="src/components/StripeIcons.tsx:90:8"
                    data-lov-name="svg"
                    data-component-path="src/components/StripeIcons.tsx"
                    data-component-line={90}
                    data-component-file="StripeIcons.tsx"
                    data-component-name="svg"
                    data-component-content="%7B%22className%22%3A%22transition-transform%20duration-300%20hover%3Ascale-110%22%7D"
                    width={20}
                    height={20}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    stroke="#D1D5DB"
                    strokeWidth={1}
                    className="transition-transform duration-300 hover:scale-110"
                  >
                    <circle
                      data-lov-id="src/components/StripeIcons.tsx:91:10"
                      data-lov-name="circle"
                      data-component-path="src/components/StripeIcons.tsx"
                      data-component-line={91}
                      data-component-file="StripeIcons.tsx"
                      data-component-name="circle"
                      data-component-content="%7B%7D"
                      cx={12}
                      cy={12}
                      r={8}
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      ;
    </>
  );
};

export default CardGroupIllustrator;
